import { StudentExamTimetable } from '@features/student-page/sub-features/student-exam-timetable/components/StudentExamTimetable'
import { ScrollArea } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_layout/students/$studentNo/exam-timetable',
)({
  component: RouteComponent,
  staticData: {
    crumb: {
        label: 'Exam Timetable',
    }
  }
})

function RouteComponent() {

    const { studentNo } = Route.useParams()

    return (
        <ScrollArea h="100%" type="auto" className="h-full min-h-0" p={5} offsetScrollbars="y">
            <StudentExamTimetable studentNo={studentNo}/>
        </ScrollArea>
    )
}
